import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import  { environment } from '../../environments/environment'
import * as CryptoJS from 'crypto-js';


const httpOptions = {
  headers: new HttpHeaders({
   'Authorization':  'Api-Key '+ environment.api_key
  })
};

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private http:HttpClient
  ) { }
  checkEmail = (email:string) =>  {
    return this
            .http
            .get(`${environment.retrieveEmail}`+ email,httpOptions);
  }
  signUp = (user:any) => {
    return this.http.post(environment.signUp,user);
  }
  passwordReset = (user:any) => {
    return this.http.post(environment.resetPassword,user);
  }
  sendCode = (webformCode:any) => {
    return this.http.post(environment.codePass,webformCode);
  } 

  sendUpdatePassword = (webformCode:any) => {
    return this.http.patch(environment.updateCodePass + webformCode.token,webformCode);
  } 

  
  login = (user:any) => {
    return this.http.post(`${environment.loginUser}`,user);
  }
  getProfile = (user:any) => {
    const profileOptions = {
        headers: new HttpHeaders({
         "Authorization": "Bearer "+ user.token
        })
      }
    return this
            .http
            .get(`${environment.getProfile}`,profileOptions);
  }
  updateProfile(payload: any) {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    const token = user?.token;
  
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  
    return this.http.patch(`${environment.updateProfile}`, payload, { headers });
  }
  
  getTrips(phone: string) {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    const token = user?.token;
  
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  
    return this.http.get(`${environment.getTrips}${phone}`, { headers });
  }
  
  makeReservation(payload: any) {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    const token = user?.token;
  
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  
    return this.http.post(`${environment.bookingApi}`, payload, { headers });
  }
  

  hashPhoneNumber(phoneNumber: string) {
    return  CryptoJS.SHA256(phoneNumber).toString();
  }

  hashEmail(email: string) {
    return  CryptoJS.SHA256(email).toString();
  }

}
